export class AccessDenied extends Error {
  name = 'Access Denied';
}
